
import { i18nText } from '@/locales';

import {Component, Vue} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import ClientsCategoriesForm from "@/form/Settings/categories/clients";
import {ClientsCategoriesSettingsStore} from "@/store/modules/ClientsCategoriesSettings"
import {IClientsCategories, IClientsCategoriesListItem} from '@/entity/clients/clientsCategories.types';
import {ClientsStore} from "@/store/modules/Clients";
import ClientsUpdateForm from "@/UI/components/forms/settings/categories/ClientsUpdateForm.vue";
import ClientsCategoriesUpdateForm from "@/form/Settings/categories/clientsUpdate";
import Api from '@/repository/api';
import {showNotificationSimple} from "@/UI/lib/messages";
import {colorsSource} from '@/UI/pages/Settings/Source/lib/colors'

import {
  FormModel, Modal,
} from "ant-design-vue";

@Component({
  components: {
    PageTitle, 
    FormGroup, 
    ClientsUpdateForm,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
  }
})
export default class Clients extends Vue {
  openPop = false
  openPopChange = false
  form = new ClientsCategoriesForm();
  updateForm = new ClientsCategoriesUpdateForm();
  modal_form: boolean = false;
  update_modal_form: boolean = false;
  colors: Array<Record<string, any>> = [];
  checkRole: boolean = false;

  get clientsCategories(): IClientsCategories | null {
    return ClientsCategoriesSettingsStore.clientCategories;
  }

  async pickColor(pc: any): Promise<void> {
    this.form.color = pc.link;

    this.openPop = false;
    this.$forceUpdate();
  }

  async pickColorChange(pc: any): Promise<void> {
    this.updateForm.color = pc.link;

    this.openPopChange = false;
    this.$forceUpdate();
  }

  get rules() {
    function validateColor(rule: Record<string, any>, color?: string) {
      let isValid = (new colorsSource).colors.filter(element => element.link === color || element.name === color).length !== 0;
      rule.message = color === undefined || color == '' ? i18nText("Это поле обязательно для заполнения") : i18nText("Неизвестный цвет");
      return isValid;
    }
    return {
      color: [{ required: true, message: i18nText("Это поле обязательно для заполнения"),  trigger: 'change' }],
      name: [{ required: true, message: i18nText("Это поле обязательно для заполнения"), trigger: 'change' }],
    }

  };

  showUpdateForm(client: IClientsCategoriesListItem): void {
    this.updateForm = new ClientsCategoriesUpdateForm();
    this.updateForm.setFormData(client);
    this.update_modal_form = true;
    this.filterColors('');
  }

  filterColors(inputVal: string): void {

    let temp = new colorsSource;
    this.colors = temp.colors.filter((color: any) => {
      // if (e.data === null) return true; // if empty filtering query return all (no filtering);

      if (color.name.toString().match(new RegExp(inputVal, 'gmi'))) {
        return true;
      }
      return false;
    });

    this.$forceUpdate();
    var timeoutId = setTimeout(() => {
      this.$forceUpdate();
    }, 500);
  }

  showDeleteForm(client: IClientsCategoriesListItem): void {
    let thisRef = this;

    Modal.confirm({
      onOk: (): void => {
        // try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let clientCategoryHasClients = client.clients && client.clients.length > 0;
        if (!clientCategoryHasClients) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ClientsCategoriesSettingsStore.delete(client).then(() => {
            thisRef.$forceUpdate();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            thisRef.clientsCategories.data = ClientsCategoriesSettingsStore.fetchAll();
          });
        } else {
          showNotificationSimple(i18nText("Запрещено"), i18nText("Нельзя удалить категорию если к ней привязан(ы) клиент(ы)!"), 5);
        }
        // } catch (e) {
        // 	console.error(e.message);
        // }
        Modal.destroyAll();
      },
      onCancel: (): void => {
        Modal.destroyAll();
      },

      autoFocusButton: "true",
      content: i18nText("Вы точно хотите удалить эту категорию?"),
      okText: i18nText("Да"),
      cancelText: i18nText("Нет"),
    });

  }

  async updateClient(): Promise<void> {
    if (await this.updateForm.submit(ClientsCategoriesSettingsStore.update)) {
      this.update_modal_form = false;
      await ClientsCategoriesSettingsStore.fetchAll();
    }
  }

  async saveCategory(): Promise<void> {
    (this.$refs.source as FormModel).validate(async (valid) => {
      if (valid) {
          try {
            if (await this.form.submit(ClientsCategoriesSettingsStore.create)) {
              await ClientsCategoriesSettingsStore.fetchAll();
            }
          } catch(e) {
            console.log("error in Clients" + e);
          } finally {
            this.modal_form = false;
          }
      }
    })
  }

  async created(): Promise<void> {

    let temp = new colorsSource;
    this.colors = temp.colors;

    this.checkRole = Vue.auth.check('owner');
    let filter = {
      limit: 20,
      filter: {with_clients: 1}
    };
    // if(!this.checkRole)
    // {
    //   filter.filter = {}
    // }

    await ClientsCategoriesSettingsStore.fetchAll(filter);


  }
}
